import { Injectable } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { EmailSettingsResponse, UpdateEmailSettingsRequest } from '@cart/shared-types';

@Injectable()
export class EmailSettingsService {
  constructor(private readonly prisma: PrismaService) {}

  async get(): Promise<EmailSettingsResponse> {
    const settings = await this.prisma.emailSettings.findFirst();

    return {
      senderEmail: settings?.senderEmail ?? undefined,
      senderName: settings?.senderName ?? undefined,
      replyToEmail: settings?.replyToEmail ?? undefined,
      logoUrl: settings?.logoUrl ?? undefined,
      primaryColor: settings?.primaryColor ?? undefined,
      providerLabel: this.providerLabel(),
      updatedAt: settings?.updatedAt.toISOString(),
    };
  }

  async update(input: UpdateEmailSettingsRequest, actorId: string): Promise<EmailSettingsResponse> {
    const existing = await this.prisma.emailSettings.findFirst();

    if (existing) {
      await this.prisma.emailSettings.update({
        where: { id: existing.id },
        data: { ...input, updatedBy: actorId },
      });
    } else {
      await this.prisma.emailSettings.create({
        data: { ...input, updatedBy: actorId },
      });
    }

    return this.get();
  }

  // Read-only in the UI — actually switching providers isn't in scope, this
  // just reflects whatever SMTP host is configured via env so Settings isn't
  // silently blank about it.
  private providerLabel(): string {
    const host = process.env.SMTP_HOST;
    return host ? `SMTP (${host})` : 'Not configured';
  }
}
